<template>
    <div>
        <property-search-header
            v-show="filterable"
            :property-details-route="propertyDetailsRoute"
            :expanded.sync="searchHeaderIsExpanded"
            :search-config="searchConfig"
            :primary-filters="primaryFilters"
            :tab-display="tabDisplay"
            :toggleable="toggleable"
            :filterable="filterable"
        />
        <property-search-content
            :property-details-route="propertyDetailsRoute"
            :default-location-overwrite="defaultLocationOverwrite"
            :favorite-option-enabled="favoriteOptionEnabled"
            :tab-display="tabDisplay"
            :toggleable="toggleable"
            :filterable="filterable"
            :map-config="mapConfig"
        />
        <filters-modal />
        <property-saved-searches-share-modal
                v-if="tabDisplay"
        />
    </div>
</template>

<script>
    import PropertySearchHeader
        from "../components/GroupPropertySearchHeader/PropertySearchHeader/PropertySearchHeader";
    import PropertySearchContent
        from "../components/GroupPropertySeachContent/PropertySearchContent/PropertySearchContent";
    import FiltersModal from "../components/Modals/FiltersModal/FiltersModal";

    export default {
        name: "PropertySearchListingPage",
        components: {
            PropertySearchHeader,
            PropertySearchContent,
            FiltersModal,
            PropertySavedSearchesShareModal: () => import(
                    "../components/GroupPropertySavedSearches/PropertySavedSearchesShareModal/PropertySavedSearchesShareModal"
                    ),
        },

        props: {
            propertyDetailsRoute: {
                type: [String, Object],
                default: 'property.details.view',
            },
            primaryFilters: {
                type: Array,
                default: () => [
                    'price',
                    'beds',
                    'baths',
                    'homeType',
                    'sale',
                ],
            },
            tabDisplay: {
                type: Boolean,
                default: true,
            },
            searchConfig: {
                type: Object,
                default: () => {
                    return {
                        apiPath: 'elasticsearch'
                    };
                },
            },
            defaultLocationOverwrite: {
                type: Array,
                default: () => [],
            },
            favoriteOptionEnabled: {
                type: Boolean,
                default: true,
            },
            filterable: {
                type: Boolean,
                default: true,
            },
            toggleable: {
                type: Boolean,
                default: false,
            },
            mapConfig: {
                type: Object,
                default: () => {
                    return {};
                }
            },
        },

        data() {
            return {
                searchHeaderIsExpanded: true,
            };
        }
    };
</script>
